/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentSystemDataTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for System Data Type API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:20 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const SystemDataTypes = {
    all: () => requests.get('/SystemDataTypes'),
    get: systemdatatypeid => requests.get(`/SystemDataType/${systemdatatypeid}`),
    create: systemdatatype => requests.post(`/SystemDataTypes`, systemdatatype),
    update: (systemdatatypeid, systemdatatype) => requests.put(`/SystemDataType/${systemdatatypeid}`, systemdatatype),
    delete: systemdatatypeid => requests.del(`/SystemDataType/${systemdatatypeid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentSystemDataTypes.js